import buildMetadata from '../../build-metadata.js'

const getBuildMetadata = async () => {
  return buildMetadata
}

export default getBuildMetadata
